<template>
  <div>
    <!-- 页名 + 查询 -->
    <div class="page_header">
      <span class="page_title">{{$t("runState.chronology")}}</span>
      <div style="flex:1;text-align: right">
        <el-form :inline="true"  style="">
          <el-form-item :label='$t("runState.mileage_run")+ "："' class="input-number">
            <el-input-number v-model="form.speed1" 
              controls-position="right" 
              :size="size"
              :min="0" 
              style="width:100px;padding-left:0px" 
            ></el-input-number>
            <span style="margin:0 8px 0 8px;color:#A2B1CB;font-size:12px">{{$t("time.to")}}</span>
            <el-input-number v-model="form.speed2" 
              controls-position="right" 
              :size="size"
              :min="0" 
              style="width:100px;padding-left:0px" 
            ></el-input-number>
          </el-form-item>
          <el-form-item :label="$t('runState.query_year_month')+ '：'"  style="margin-left:20px">
            <el-select v-model="year" placeholder="" :size="size" filterable style="width:95px;margin-right:10px">
              <el-option
                v-for="(option, index) in  yearOptions"
                :key="index"
                :label="option.label"
                :value="option.value"
              ></el-option>
            </el-select>
            <el-select v-model="month" placeholder="" :size="size" filterable style="width:95px">
              <el-option
                v-for="(option, index) in  monthOptions"
                :key="index"
                :label="option.label" 
                :value="index"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item>
            <el-button 
              type="primary" 
              :size="size"
              style="margin-left:8px;"
              @click="handleQuery"
            >{{ $t("public.query")}}</el-button>
          </el-form-item>
        </el-form>
      </div>
    </div>
    <div class="page_container" style="font-size:12px;">
      <!-- 车辆计划列表 -->
      <div style="background-color:#E8F0FF;height:52px;border:1px solid #D9E4F8;border-bottom:0;display:flex;align-items: center;padding:0 20px 0 20px ">
        <div>
          <i class="iconfont icon-icon_tab_list" ></i>
          <span style="margin-left:8px;font-weight: bold;">{{$t('runState.chronology')}}</span>
        </div>
        <div style="flex:1;text-align:right">
          <span class="tag"><el-tag size="mini" color="#07B477" style="height:16px;width:16px;"></el-tag></span>
          <span class="tag-text">0 ~ {{mileageRange[0]}} {{$t('runState.km')}}</span>
          <span class="tag"><el-tag size="mini" color="#FF8C00" style="height:16px;width:16px;"></el-tag></span>
          <span class="tag-text">{{mileageRange[0]}} ~ {{mileageRange[1]}} {{$t('runState.km')}}</span>
          <span class="tag"><el-tag size="mini" color="#FF106E" style="height:16px;width:16px;"></el-tag></span>
          <span class="tag-text">{{mileageRange[1]}} {{$t('runState.km_more')}}</span>
          <span class="tag"><el-tag size="mini" color="#E8F0FF" style="height:16px;width:16px;" effect="plain"></el-tag></span>
          <span>{{$t('runState.no_mileage_data')}} </span>            
        </div>
      </div>
      <!-- 表格  -->
      <div class="table">
        <el-table :data="dataList" :size="size" border v-loading="loading" style="width:100%" :height="tableHeight">
          <el-table-column :label="$t('public.date')" prop="carNo" align="center" width="150" fixed>
            <el-table-column :label="$t('runState.carNo')" prop="carNo" align="center" width="150" fixed></el-table-column>
          </el-table-column>
          
          <el-table-column v-for="(item,index) in monthDay" :key="index" :label="item.toString()" :min-width="40" align="center">
            <template slot-scope="scope">
              <div v-if="scope.row">
                <el-tooltip :content="cellTip(scope.row,item)" placement="bottom" effect="light" :disabled="isCellTip(scope.row,item)">
                  <span :class="{tag_none: tag_none(scope.row,item)}"><el-tag size="mini" :color="cellColor(scope.row,item).color" style="height:22px;width:22px;"></el-tag></span>
                </el-tooltip>
              </div>
            </template>
          </el-table-column>
        </el-table>
      </div>
    </div>
  </div>
</template>
<script>
import { mapState } from 'vuex';
import language from '@/utils/getLanguageId'
import settings from "@/settings";
export default {
  name: "velOChronology",
  data(){
    return{
      mileageRange:[],
      loading:false,
      dataList:[],
      yearOptions:[],
      monthOptions:[],
      year:"",
      month:"",
      monthDay:0,
      form:{
        speed1:100,
        speed2:400,
      },
      vehicles:"",
      LanguageId:1,
      tableHeight: window.innerHeight - 265,
    }
  },
  computed: {
    ...mapState({
        selectedVehicles: state => state.app.vehicles.selectedVehicles,
        appVehicles: state => state.app.vehicles,
        selectedVehicles: state => state.app.vehicles.selectedVehicles,
    }),
    size() {
        return this.$store.getters.size
    },
    operator() {
        return this.$store.getters.operator
    },
  },
  watch:{
    year(newVal){
      //今年，月份限制到本月
      let nowYear = new Date().getFullYear();
      let nowMonth = new Date().getMonth();
      if(newVal == nowYear){
        this.monthOptions =  this.monthOptions.slice(0, nowMonth + 2);
      }else{
        this.monthOptions = [
          {
              value: 0,
              label:this.$t("public.all") 
            },
            {
              value:1,
              label:this.$t("time.January")
            },
            {
              value:2,
              label:this.$t("time.February")
            },
            {
              value:3,
              label:this.$t("time.March")
            },
            {
              value:4,
              label:this.$t("time.April")
            },
            {
              value:5,
              label:this.$t("time.May")
            },
            {
              value:6,
              label:this.$t("time.June")
            },
            {
              value:7,
              label:this.$t("time.July")
            },
            {
              value:8,
              label:this.$t("time.August")
            },
            {
              value:9,
              label:this.$t("time.September")
            },
            {
              value:10,
              label:this.$t("time.October")
            },
            {
              value:11,
              label:this.$t("time.November")
            },
            {
              value:12,
              label:this.$t("time.December")
            },
          
        ];
      }
    },
  },
  methods:{
    updateTableHeight() {
      this.tableHeight = window.innerHeight - 265; // 
    },
    getSelectedVehicles(){
      this.vehicles = "";
      for(let k = 0; k < this.selectedVehicles.length; k++){
        if(this.selectedVehicles[k].treeLevel == 5){
          this.vehicles = this.vehicles + this.selectedVehicles[k].nodeValue + ",";
        }
      }
      return this.vehicles.substring(0,this.vehicles.length-1);
    },
    //是否显示提示框
    isCellTip(row,index){
      index = index <= 9 ? "0" + index : index;
      const cellData = eval("row.m"+index);
      if(cellData == 0 || cellData == "" || cellData == undefined){
        return true;
      }else return false;
    },
    //提示框内容
    cellTip(row,index){
    // console.log(this.monthOptions[index]);
      index = index <= 9 ? "0" + index : index;
      const cellData = eval("row.m"+index);
      if(!(cellData == 0 || cellData == "" || cellData == undefined)){
        if(this.month == 0){
          switch(this.LanguageId){
            case 1://中文
              return this.year + "年" + index + "月" + "运行里程：" + cellData + this.$t("runState.km");
              break;
            case 3://英文
              return this.year + "-" + index + this.$t("runState.mileage_run") + "：" + cellData + " " + this.$t("runState.km");
              break;
            default:
              return this.year + "-" + index + this.$t("runState.mileage_run") + "：" + cellData + " " + this.$t("runState.km");
              break;
          }
        }else{
          var itemMonth = this.month <= 9 ? "0" + this.month : this.month;
          switch(this.LanguageId){
            case 1://中文
              return this.year + "年" + itemMonth + "月" + index + "日" + "运行里程：" + cellData + this.$t("runState.km");
              break;
            case 3://英文
              return this.year + "-" + itemMonth + "-" + index + " " + this.$t("runState.mileage_run") + "：" + cellData + " " + this.$t("runState.km");
              break;
            default:
              return this.year + "-" + itemMonth + "-" + index + " " + this.$t("runState.mileage_run") + "：" + cellData + " " + this.$t("runState.km");
              break;
          }
        }
      }
    },
    //判断单元格是否有数值,鼠标光标变成手型
    tag_none(row,index){
      index = index <= 9 ? "0" + index : index;
      if(eval("row.m"+index) == 0 || eval("row.m"+index) == "" || eval("row.m"+index) == undefined){
        return false;
      }else return true;
    },
    //根据数值判断单元格颜色
    cellColor(row,index){
      // console.log(eval("row.day_"+index));
      index = index <= 9 ? "0" + index : index;
      let val = eval("row.m"+index);
      switch(true){
        case (0<val && val<this.mileageRange[0]):
          return {"val":val,"color":"#07B477"};
        case (this.mileageRange[0] <= val && val < this.mileageRange[1]):
          return {"val":val,"color":"#FF8C00"};
        case (val >= this.mileageRange[1]):
          return {"val":val,"color":"#FF106E"};
        default :
          return {"val":val,"color":"#E8F0FF"};
      }

    },
    //初始化年月选择
    initOption(){
      this.month = new Date().getMonth() + 1;
      let nowYear = new Date().getFullYear();
      this.year = nowYear;
      //可往前查7年
      for(let i = 7;i>0;i--){
        let val = this.year - i;
        this.yearOptions.push(
          {
            value: val,
            label: val,
          }
        )
      }
      this.yearOptions.push({value: nowYear,label: nowYear})

      this.monthOptions = [
            {
              value: 0,
              label:this.$t("public.all") 
            },
            {
              value:1,
              label:this.$t("time.January")
            },
            {
              value:2,
              label:this.$t("time.February")
            },
            {
              value:3,
              label:this.$t("time.March")
            },
            {
              value:4,
              label:this.$t("time.April")
            },
            {
              value:5,
              label:this.$t("time.May")
            },
            {
              value:6,
              label:this.$t("time.June")
            },
            {
              value:7,
              label:this.$t("time.July")
            },
            {
              value:8,
              label:this.$t("time.August")
            },
            {
              value:9,
              label:this.$t("time.September")
            },
            {
              value:10,
              label:this.$t("time.October")
            },
            {
              value:11,
              label:this.$t("time.November")
            },
            {
              value:12,
              label:this.$t("time.December")
            },
            
          ];
    },
    handleQuery(){
      if(this.form.speed1 == undefined || this.form.speed2 == undefined){
        this.$message({
          message: this.$t("runState.mileage_range"),//'请填写运行里程范围',
          type: 'warning'
        });
        return ;
      }
      //因为需要speed1<speed2,做下调整
      if(this.form.speed1 > this.form.speed2){
        let item = this.form.speed1;
        this.form.speed1 = this.form.speed2;
        this.form.speed2 = item;
      }
      this.mileageRange = [this.form.speed1, this.form.speed2];
      if(this.month == 0){
        this.monthDay = 12;
      }else{
        this.monthDay = new Date(this.year,this.month, 0).getDate();
      }
      this.vehicles = this.getSelectedVehicles();
      this.getList();
      // console.log(this.year,"年",this.month,"月",this.monthDay);
    },
    getList(){
      // console.log(this.month);
      this.loading = true;
      this.$api.chronologyInfo({
        OperatorID: this.operator.OperatorId + "",
        year: this.year + "",
        month: this.month <=9 ? "0" + this.month : this.month + "",
        vehicles: this.vehicles
      })
      .then((res)=>{
        if(res && res.code == 200){
          this.dataList = res.data;
          this.loading = false;
        }
      })
      .catch((e)=>{
        this.dataList = []
        this.loading = false;
      })
    },
  },
  mounted(){
      const currentPath = this.$route.path
    // 从全局变量中取出对应路由的开始时间
    const startTime = settings.routeStartTime[currentPath]
    if (startTime) {
      // 计算耗时（mounted时组件已挂载到DOM，UI基础展示完成）
      const renderTime = Date.now() - startTime
      console.log(`路由 ${currentPath} 渲染耗时：${renderTime}ms`)
      // 可选：上报到后端或日志系统
      // reportRenderTime(currentPath, renderTime)

      // 清除已计算的开始时间，避免重复计算
      delete settings.routeStartTime[currentPath]
    }
    this.initOption();
    this.mileageRange = [this.form.speed1,this.form.speed2];
    if(this.month == 0){
      this.monthDay = 12;
    }else{
      this.monthDay = new Date(this.year,this.month, 0).getDate();
    }

    this.updateTableHeight();
    this.handleQuery();
    this.LanguageId = language(this.$store.getters.locale);
    // 监听窗口大小变化事件
    window.addEventListener('resize', this.updateTableHeight);
  },
  beforeDestroy() {
    // 在组件销毁前移除事件监听
    window.removeEventListener('resize', this.updateTableHeight);
  },
}
</script>
<style lang="scss" scoped>
.table {
  ::v-deep .el-table tr {
        background: rgb(244, 248, 255);
    }

  ::v-deep .el-table {
        background: rgb(244, 248, 255);
    }

    ::v-deep .el-table td {
        background: rgb(244, 248, 255);
    }
} 

::v-deep  .el-table thead.is-group th {
    background: none;
    padding: 0px;
}

::v-deep .el-table thead.is-group tr:first-of-type th:first-of-type {
    border-bottom: none;/*中间的横线去掉*/
}

::v-deep .el-table thead.is-group tr:first-of-type th:first-of-type div.cell {
    text-align: right;/*上边文字靠右*/
}

::v-deep .el-table thead.is-group tr:last-of-type th:first-of-type div.cell {
    text-align: left;/*下边文字靠左*/
}
::v-deep .el-table thead.is-group tr:first-of-type th:first-of-type:before {
    content: "";
    position: absolute;
    width: 1px;
    height: 100px;/*斜线的长度*/
    top: 0;
    left: 0;
    background-color: grey;
    opacity: 0.2;
    display: block;
    transform: rotate(-43deg);/*调整斜线的角度*/
    transform: rotate(-70deg);/*调整斜线的角度*/
    -webkit-transform-origin: top;
    transform-origin: top;
}

::v-deep .el-table thead.is-group tr:last-of-type th:first-of-type:before {
    content: "";
    position: absolute;
    width: 1px;
    height: 100px;/*斜线的长度*/
    bottom: 0;
    right: 0;
    background-color: grey;
    opacity: 0.2;
    display: block;
    transform: rotate(-45deg);/*调整斜线的角度*/
    transform: rotate(-70deg);/*调整斜线的角度*/
    -webkit-transform-origin: bottom;
    transform-origin: bottom;
}
::v-deep .el-table thead.is-group th{
    height: 27.4px;
}


.tooltip {
  position: fixed;
  padding: 5px;
  background-color: white;
  color: rgb(92, 83, 83);
  border: 1px solid #0F1A3A;
  border-radius: 3px;
}
.tag_none{
  cursor: pointer;
}
.tag{
  margin-right: 8px;
}
.tag-text{
  margin-right: 20px;
}
::v-deep .el-table th {
      background-color: rgb(244, 248, 255) !important;
}

.input-number   {
  ::v-deep .el-input {
    position: relative;
    &::before {
      // 也可以将此处的分钟换成其他单位
      content: "km";
      position: absolute;
      top: 0;
      right: 25px;
      height: 32px;
      line-height: 35px;
      color: #0F1A3A;
      font-size: 12px;
    }
  }
  // .el-input__inner {
  //   padding-right: 64px;
  // }

  ::v-deep  .el-input-number {
    &__increase,
    &__decrease {
      background-color: transparent ;
      border: 0 !important;
      width: 25px ;
    }
    .el-icon-arrow-up::before {
      content: "";
    }
    .el-icon-arrow-down::before {
      content: "";
    }
    &.is-controls-right .el-input-number__decrease [class*=el-icon],
    &.is-controls-right .el-input-number__increase [class*=el-icon] {
      transform: scale(1.1);
    }
  }
  ::v-deep .el-input-number.is-controls-right .el-input__inner{
    padding-left: 5px;
  }
}

.el-form-item {
    margin-bottom: 0px !important;
}

//el-table 固定列与横向滚动条冲突
.el-table .el-table__fixed {
  pointer-events: none;
}
.el-table .el-table__fixed > *{
  pointer-events:all;
}
.el-table .el-table__fixed-right {
  pointer-events: none;
}
.el-table__fixed-right > *{
  pointer-events:all;
}
</style>